import { defineMessages } from "react-intl";
export var messages = defineMessages({
  globSettingsTitle: {
    id: "jutro-components.GlobalizationSettingsCard.title",
    defaultMessage: "Language and Regional Format"
  }
});